import request from '@/utils/request.js';

export const apiPostPay =
    data => request("post",'/api/v1/pay',data)
            .then(function(res){
                return res.data ;
            });
